import MakePayment from "./MakePayment";

export default MakePayment;
